// CanvasItemWrapper.tsx
import styled from "styled-components";
import { Box } from "@thenounproject/lingo-core";

type CanvasItemWrapperProps = {
  index: number;
  itemId: string;
  outerWidth?: string;
  size?: number;
};

export const CanvasItemWrapper = styled(Box).attrs<CanvasItemWrapperProps>(
  ({ outerWidth = "100%", size = 1, index, itemId }) => ({
    width: outerWidth,
    minWidth: 100,
    "data-size": size,
    "data-droppable-item": true,
    "data-item-index": index,
    "data-item-id": itemId,
    style: { flexShrink: 0 },
  })
)<CanvasItemWrapperProps>``;
